export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7552.bccb8a9c.jpg";